import { useQuery } from '@tanstack/react-query';

import { luccaControllerGetStatus } from './generated';

/**
 * Feature flag: is the Lucca integration configured on the backend
 * (LUCCA_BASE_URL + LUCCA_TOKEN both set)? Returns false while loading, so
 * employee UI stays hidden until confirmed enabled. Cached for the session.
 */
export function useLuccaEnabled(): boolean {
  const { data } = useQuery({
    queryKey: ['lucca-status'],
    queryFn: async () => {
      const { data } = await luccaControllerGetStatus({ throwOnError: true });
      return data;
    },
    retry: false,
    staleTime: Infinity,
  });
  return data?.enabled ?? false;
}
